import { useTranslation } from 'react-i18next'
import LogoLight from '../assets/images/logo_light.svg'
import { MapPinIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid'

const Footer = () => {
	const { t, i18n } = useTranslation()
	return (
		<footer className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white font-noto overflow-hidden">
			{/* Background pattern */}
			<div className="absolute inset-0 opacity-5">
				<div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
				<div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
				<div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
			</div>

			<div className="relative z-10 px-4 py-16">
				<div className="container mx-auto">
					{/* Main content */}
					<div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-12">
						{/* Company info */}
						<div className="lg:col-span-2">
							<div className="mb-8">
								<h3 className="text-3xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
									MindCline
								</h3>
							</div>

							<div className="space-y-4">
								<div className="flex items-start space-x-4 group">
									<div className="flex-shrink-0 w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500/30 transition-colors">
										<MapPinIcon className="w-5 h-5 text-blue-400" />
									</div>
									<div>
										<p className="text-gray-300 leading-relaxed">{t('footer.address')}</p>
									</div>
								</div>

								{i18n.language !== 'ja' && i18n.language !== 'ja-JP' && (
									<div className="flex items-center space-x-4 group">
										<div className="flex-shrink-0 w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center group-hover:bg-green-500/30 transition-colors">
											<PhoneIcon className="w-5 h-5 text-green-400" />
										</div>
										<div>
											<a
												href="tel:+82-02-585-0925"
												className="text-gray-300 hover:text-green-400 transition-colors"
											>
												{t('footer.tel')}
											</a>
										</div>
									</div>
								)}

								<div className="flex items-center space-x-4 group">
									<div className="flex-shrink-0 w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center group-hover:bg-purple-500/30 transition-colors">
										<EnvelopeIcon className="w-5 h-5 text-purple-400" />
									</div>
									<div>
										<a
											href="mailto:contact@mindcline.com"
											className="text-gray-300 hover:text-purple-400 transition-colors"
										>
											{t('footer.email')}
										</a>
									</div>
								</div>
							</div>
						</div>

						{/* Logo section */}
						<div className="flex items-center justify-center lg:justify-end">
							<div className="relative group">
								<div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl opacity-20 group-hover:opacity-30 transition-opacity blur-lg"></div>
								<img
									src={LogoLight}
									alt="MindCline"
									className="relative w-64 h-auto filter drop-shadow-2xl group-hover:scale-105 transition-transform duration-300"
								/>
							</div>
						</div>
					</div>

					{/* Bottom section */}
					<div className="pt-8 border-t border-white/10">
						<div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0">
							<p className="text-gray-400 text-sm">
								2025 &copy; MindCline. All rights reserved.
							</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
